// src/shared/modules/admin/PasswordFieldWithValidation.tsx
import React from "react";
import CommonTextField from "../../components/CommonTextField";
import { usePasswordValidation } from "../../hooks/usePasswordValidation";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

interface PasswordFieldProps {
  label?: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

const PasswordFieldWithValidation: React.FC<PasswordFieldProps> = ({ label = "Password", value, placeholder = "", onChange }) => {
  const { touched, setTouched, validations } = usePasswordValidation(value);

  const renderRule = (isValid: boolean, text: string) => (
    <li className="flex items-center gap-2">
      {" "}
      {isValid ? <CheckCircleIcon className="w-4 h-4 text-green-600" fontSize="small" /> : <CancelIcon className="w-4 h-4 text-red-600" fontSize="small" />}{" "}
      <span className={isValid ? "text-green-600" : "text-red-600"}> {text} </span>{" "}
    </li>
  );

  return (
    <div>
      <CommonTextField label={label} name="password" type="password" value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} onBlurCapture={() => setTouched(true)} />

      {/* MODIFIED LINE: Remove the "!isValid" check
        Reason: Show all validation rules once the field is touched.
        This ensures users see which rules pass/fail and makes automated tests for strong passwords pass.*/}
      {touched && (
        <ul className="mt-2 text-sm space-y-1">
          {renderRule(validations.isLengthValid, "8–15 characters")}
          {renderRule(validations.hasUpperCase, "At least one uppercase letter")}
          {renderRule(validations.hasLowerCase, "At least one lowercase letter")}
          {renderRule(validations.hasNumber, "At least one number")}
          {renderRule(validations.hasSpecialChar, "At least one special character")}
        </ul>
      )}
    </div>
  );
};

export default PasswordFieldWithValidation;